import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';

export function useCommodityList() {
  const { userMappingService } = useService();

  const { data, isFetching } = useQuery([QUERY_KEYS.commodityList], () => userMappingService.getCommodities());

  return { commodities: data, isFetching } as const;
}
